// ts-rest contract for the priority action inbox (SEP-228 §37).
//
// Two routes. One lists the open actions of the caller. One clears a single
// action.
//
// Neither route takes an audience, a user or a team. The server reads the
// identity of the caller and derives the scope from it. A desk caller reads the
// actions of their own book only, because an investment manager must never read
// the business of another manager.

import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { errorBodyWithCode as errorBody } from '../schemas/common';
import {
    clearPriorityActionRequestSchema,
    priorityActionsResponseSchema,
} from '../schemas/priority-actions';

const c = initContract();

export const priorityActionsContract = c.router(
    {
        list: {
            method: 'GET',
            path: '/priority-actions',
            responses: {
                200: priorityActionsResponseSchema,
            },
            summary: 'The open priority actions of the caller, scoped to their identity',
        },
        clear: {
            method: 'POST',
            path: '/priority-actions/clear',
            body: clearPriorityActionRequestSchema,
            responses: {
                200: z.object({ ok: z.literal(true) }),
                404: errorBody,
            },
            summary: 'Clear one open priority action that the caller can see',
        },
    },
    { pathPrefix: '/api' },
);
